import { Directive, inject } from '@angular/core';
import { TourAnchorMatMenuDirective } from 'ngx-ui-tour-md-menu';

@Directive({
  selector: '[lassiOnboardingAnchor]',
  hostDirectives: [
    {
      directive: TourAnchorMatMenuDirective,
      inputs: ['tourAnchor:lassiOnboardingAnchor'],
    },
  ],
  host: {
    '[class.onboarding-active]': 'onboarding.isActive()',
  },
})
export class OnboardingDirective {
  onboarding = inject(TourAnchorMatMenuDirective);
}
